module.exports = __webpack_public_path__ + "static/media/gardengreensalad.3e5f89b1.jpg";